var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QuizChoiceForm',_vm._g({attrs:{"data":_vm.data,"staticAnswers":false,"title":_vm.$t('QUIZZES.LABEL.ABCD_SCREEN'),"showManualCheck":_vm.showManualCheck}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }